<div class="inner" #inner>
  <ng-content/>
</div>
